import { LandlineCheckProvider } from 'components/providers/LandlineCheckProvider'

import { ReactNode } from 'react'

import * as Styled from './styled'

interface AppContainerProps {
  children: ReactNode
}

export default function AppContainer(props: AppContainerProps) {
  return (
    <Styled.AppContainer id="app-root" container sx={{ height: '100vh' }}>
      <LandlineCheckProvider>{props.children}</LandlineCheckProvider>
    </Styled.AppContainer>
  )
}
